import React, { useEffect } from "react";
import Sidebar from "../layout/Sidebar";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserData } from "../../redux/features/accountSlice";
import { ShoppingBag, MapPin, User, Heart } from "lucide-react";
import { useTranslation } from "react-i18next";

const Dashboard = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.account);

  useEffect(() => {
    dispatch(fetchUserData());
  }, [dispatch]);

  const cards = [
    { title: `${t("Orders")}`, icon: <ShoppingBag size={26} />, link: "/order" },
    { title: `${t("Address")}`, icon: <MapPin size={26} />, link: "/address" },
    { title: `${t("Account_Detail")}`, icon: <User size={26} />, link: "/account" },
    { title: `${t("Wishlist")}`, icon: <Heart size={26} />, link: "/wishlist" },
  ];

  return (
    <section className="pt-5 pb-5 bg-light min-vh-100">
      <div className="container">
        <div className="row">
          {/* Sidebar */}
          <div className="col-lg-3 mb-4">
            <Sidebar />
          </div>

          {/* Dashboard Content */}
          <div className="col-lg-9">
            <div className="card border-0 shadow-sm rounded-4 p-4 bg-white">
              <div className="mb-4">
                <h4 className="fw-semibold mb-1 text-dark">
                  {`${t('Hello')}`},{" "}
                  <span className="text-primary">
                    {profile?.first_name} {profile?.last_name}
                  </span>
                </h4>
                <p className="text-muted mb-0">
                  {`${t('Welcome_back')}`}
                </p>
              </div>

              {/* Dashboard Quick Links */}
              <div
                className="d-flex flex-wrap justify-content-start gap-3"
                style={{ rowGap: "20px", columnGap: "20px" }}
              >
                {cards.map((card) => (
                  <Link
                    key={card.title}
                    to={card.link}
                    className="text-decoration-none flex-grow-1"
                    style={{ flexBasis: "calc(25% - 20px)", minWidth: "160px" }}
                  >
                    <div
                      className="dashboard-card d-flex flex-column align-items-center justify-content-center rounded-4 text-center shadow-sm"
                      style={{
                        height: "150px",
                        backgroundColor: "var(--secondary-light-color, #007bff)",
                        color: "#fff",
                        transition: "all 0.3s ease",
                      }}
                    >
                      <div className="mb-2">{card.icon}</div>
                      <p className="fw-semibold mb-0 text-white">{card.title}</p>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Dashboard;
